import { takeEvery, takeLatest, put, call } from "redux-saga/effects";
import {
  FETCH_EMPLOYEES_REQUEST,
  CREATE_EMPLOYEE_REQUEST,
  EMPLOYEE_DROPDOWN_REQUEST,
  EMPLOYEE_DROPDOWN_AUTO_LIST_REQUEST,
  FETCH_EMPLOYEE_TAB_WISE_INFO,
  DELETE_DOCUMENT_REQUEST,
  DELETE_DOCUMENT_SUCCESS,
  DELETE_DOCUMENT_FAILURE,
  FETCH_ACTIVE_EMPLOYEES_REQUEST,
  FETCH_EMPLOYEE_VIEW_PROFILE_REQUEST,
  FETCH_TRANSFER_TYPES,
  FETCH_FROM_CATEGORY,
  FETCH_FROM_DESIGNATION,
  FETCH_FROM_DEPARTMENT,
  FETCH_REPORTING,
  FETCH_EMPLOYEELISTTOTRANSFER,
  SAVE_TRANSFER_REQUEST,
  FETCH_TRANSFERLOGS,
  CLEAR_EMPLOYEE_LIST,
  GET_SHIFT_GROUP_DETAILS_SUCCESS,
  GET_SHIFT_GROUP_DETAILS_FAILURE,
  GET_SHIFT_GROUP_DETAILS,
  EMPLOYEE_DROPDOWN_AUTO_LIST_EXTRADUTY_REQUEST,
  FETCH_NEXT_EMP_NO_REQUEST,
  FETCH_NEXT_EMP_NO_SUCCESS,
  FETCH_NEXT_EMP_NO_FAILURE,
  EMPLOYEE_DROPDOWN_AUTO_LIST_MOBILEPUNCH_REQUEST,
} from "./actionTypes";
import {
  fetchEmployeesSuccess,
  fetchEmployeesFailure,
  createEmployeeSuccess,
  createEmployeeFailure,
  fetchEmployeeDropdownSuccess,
  fetchEmployeeDropdownFailure,
  fetchEmployeeDropdownAutoListSuccess,
  fetchEmployeeDropdownAutoListFailure,
  fetchEmployeeTabWiseInfoSuccess,
  fetchEmployeeTabWiseInfoFailure,
  fetchEmployeeTabWiseInfo,
  deleteDocumentSuccess,
  deleteDocumentFailure,
  fetchActiveEmployeesSuccess,
  fetchActiveEmployeesFailure,
  fetchEmployeeViewProfileSuccess,
  fetchEmployeeViewProfileFailure,
  clearEmployeeList,
  fetchTransferTypesSuccess,
  fetchTransferTypesFailure,
  fetchCategorySuccess,
  fetchCategoryFailure,
  fetchEmployeeListtoTransferSuccess,
  fetchEmployeeListtoTransferFailure,
  fetchDesignationSuccess,
  fetchDesignationFailure,
  fetchDepartmentSuccess,
  fetchDepartmentFailure,
  fetchReportingSuccess,
  fetchReportingFailure,
  fetchTransferLogsSuccess,
  fetchTransferLogsFailure,
  SaveTransferSuccess,
  SaveTransferFailure,
  fetchEmployeeDropdownAutoExtraDutyListSuccess,
  fetchEmployeeDropdownAutoExtraDutyListFailure,
  fetchNextEmpNoSuccess,
  fetchNextEmpNoFailure,
  fetchEmployeeDropdownAutoListMobilePunchSuccess,
  fetchEmployeeDropdownAutoListMobilePunchFailure,

} from "./actions";
import { post, get } from "../../../helpers/api_helper"; // Update with the correct API helper functions
import Swal from "sweetalert2";

// Fetch Employees
function* fetchEmployeesSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_EMPLOYEE_SEARCH, action.payload); // Replace with actual endpoint
    yield put(fetchEmployeesSuccess(response));
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put(fetchEmployeesFailure(error.message));
  }
}

// Worker Saga for Creating Employee
function* createEmployeeSaga({ payload: { data, tabName, history } }) {
  try {
    let API_URL = "";

    const apiEndpoints = {
      personal: process.env.REACT_APP_EMPLOYEE_PERSONAL_SAVE,
      account: process.env.REACT_APP_EMPLOYEE_BANK_ACCOUNT_SAVE,
      document: process.env.REACT_APP_EMPLOYEE_DOCUMENTS_SAVE,
      education: process.env.REACT_APP_EMPLOYEE_EDUCATION_SAVE,
      family: process.env.REACT_APP_EMPLOYEE_FAMILY_SAVE,
      organization: process.env.REACT_APP_EMPLOYEE_ORG_INFO_SAVE,
      equipment: process.env.REACT_APP_EMPLOYEE_EQUIPMENT_SAVE,
      work_exp: process.env.REACT_APP_EMPLOYEE_WORK_EXPERIENCE_SAVE,
      personal_org: process.env.REACT_APP_EMPLOYEE_PERSONAL_AND_ORG_SAVE,
      // work_exit: process.env.REACT_APP_EMPLOYEE_WORK_EXIT_SAVE,
    };

    API_URL = apiEndpoints[tabName] || "";

    const response = yield call(post, API_URL, data);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to create employee!");
    }
    yield put(createEmployeeSuccess(response));
    const empId = response.empid;
    if (empId && empId !== "0") {
      if (tabName === 'personal_org') {
        history.push('/manage-employee'); // ✅ Navigate to manage-employee
      } else {
        yield put(fetchEmployeeTabWiseInfo(empId, tabName));
      }
    }
    // Success alert
    Swal.fire({
      title: "Success",
      text: response?.message,
      icon: "success",
      confirmButtonText: "OK",
    });
  } catch (error) {
    yield put(createEmployeeFailure(error));

    // Error alert
    Swal.fire({
      title: "Error",
      text: error.message,
      icon: "error",
      confirmButtonText: "OK",
    });
  }
}

function* fetchEmployeeDropdownSaga({ payload: { unit_id } }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", unit_id);
    const response = yield call(post, process.env.REACT_APP_EMPLOYEE_DROPDOWN_LIST, formData); // Replace with actual endpoint
    yield put(fetchEmployeeDropdownSuccess(response));
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put(fetchEmployeeDropdownFailure(error.message));
  }
}

function* fetchEmployeeDropdownAutoListSaga({ payload: { unit_id } }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", unit_id);
    const response = yield call(post, process.env.REACT_APP_EMPLOYEE_DROPDOWN_AUTO_LIST, formData);
    yield put(fetchEmployeeDropdownAutoListSuccess(response));
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put(fetchEmployeeDropdownAutoListFailure(error.message));
  }
}

function* fetchEmployeeTabWiseSaga({ payload: { empId, tabName } }) {
  try {
    const formData = new FormData();
    formData.append("emp_id", empId);
    const apiEndpoints = {
      personal: process.env.REACT_APP_EMPLOYEE_PERSONAL_FETCH,
      account: process.env.REACT_APP_EMPLOYEE_BANK_ACCOUNT_FETCH,
      document: process.env.REACT_APP_EMPLOYEE_DOCUMENTS_FETCH,
      education: process.env.REACT_APP_EMPLOYEE_EDUCATION_FETCH,
      family: process.env.REACT_APP_EMPLOYEE_FAMILY_FETCH,
      organization: process.env.REACT_APP_EMPLOYEE_ORG_INFO_FETCH,
      equipment: process.env.REACT_APP_EMPLOYEE_EQUIPMENT_FETCH,
      work_exp: process.env.REACT_APP_EMPLOYEE_WORK_EXPERIENCE_FETCH,
      work_exit: process.env.REACT_APP_EMPLOYEE_WORK_EXIT_FETCH,
      personal_org: process.env.REACT_APP_EMPLOYEE_PERSONAL_FETCH,
    };

    const API_URL = apiEndpoints[tabName];

    if (!API_URL) {
      throw new Error(`Invalid tab name: ${tabName}`);
    }

    const response = yield call(post, API_URL, formData);

    if (response.status === "success") {
      yield put(fetchEmployeeTabWiseInfoSuccess({ tabName, data: response.data }));
    } else {
      yield put(fetchEmployeeTabWiseInfoFailure(response.message || "Failed to fetch data"));
    }
  } catch (error) {
    yield put(fetchEmployeeTabWiseInfoFailure(error));
  }
}

function* deleteDocumentSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_EMPLOYEE_DOCUMENT_REMOVE, action.payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to delete document!");
    }
    yield put(deleteDocumentSuccess(response));
    const empId = response.empid;
    if (empId) {
      yield put(fetchEmployeeTabWiseInfo(empId, 'document'));
    }
    // Success alert
    Swal.fire({
      title: "Success",
      text: response?.message,
      icon: "success",
      confirmButtonText: "OK",
    });
  } catch (error) {
    yield put(deleteDocumentFailure(error.message));
  }
}

// Fetch Employees
function* fetchActiveEmployeesSaga(action) {
  const { unit_id } = action.payload;
  try {
    const formData = new FormData();
    formData.append("unit_id", unit_id);
    const response = yield call(post, process.env.REACT_APP_EMPLOYEES_ACTIVE_LIST, formData); // Replace with actual endpoint
    yield put(fetchActiveEmployeesSuccess(response));
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put(fetchActiveEmployeesFailure(error.message));
  }
}

function* fetchEmployeeViewProfileSaga({ payload: { emp_id } }) {
  console.log('emp_id > ', emp_id)
  try {
    const formData = new FormData();
    formData.append("emp_id", emp_id);
    const response = yield call(post, process.env.REACT_APP_EMPLOYEE_VIEW_PROFILE, formData);
    yield put(fetchEmployeeViewProfileSuccess(response.data));
  } catch (error) {
    yield put(fetchEmployeeViewProfileFailure(error.message));
  }
}

//Transfer Types ----------------------------------------------------------------------Dinesh ---------------------------------
function* fetchTransferTypesSaga({ payload: { unit_id } }) {
  //console.log("dinesh response: ",{ payload: { unit_id } })
  //  const {unit_id} = action.payload;
  try {
    const formData = new FormData();
    formData.append("unit_id", unit_id);
    const response = yield call(post, process.env.REACT_APP_FETCH_TRANSFERTYPES, formData); // Replace with actual endpoint
    yield put(fetchTransferTypesSuccess(response));
  } catch (error) {
    console.error("Saga API Error:", { payload: { unit_id } });
    yield put(fetchTransferTypesFailure(error.message));
  }
}

function* fetchFromCategorySaga({ payload: { unit_id } }) {
  console.log("unit_id:", unit_id);
  try {
    const formData = new FormData();
    formData.append("unit_id", unit_id);
    const response = yield call(post, process.env.REACT_APP_GET_CATEGORIES, formData); // Replace with actual endpoint
    yield put(fetchCategorySuccess(response));
  } catch (error) {
    console.error("Saga API Error:", { payload: { unit_id } });
    yield put(fetchCategoryFailure(error.message));
  }
}

function* fetchEmployeeListSaga1(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_GETEMPLOYEELISTTOTRANSFER, action.payload); // Replace with actual endpoint
    yield put(fetchEmployeeListtoTransferSuccess(response));
  } catch (error) {
    console.error("Saga API Error:", { payload: { unit_id } });
    yield put(fetchEmployeeListtoTransferFailure(error.message));
  }
}

function* fetchFromDesignationSaga({ payload: { unit_id } }) {
  //  console.log("unit_id:",unit_id);
  try {
    const formData = new FormData();
    formData.append("unit_id", unit_id);
    const response = yield call(post, process.env.REACT_APP_GET_DESIGNATIONS, formData); // Replace with actual endpoint
    yield put(fetchDesignationSuccess(response));
  } catch (error) {
    console.error("Saga API Error:", { payload: { unit_id } });
    yield put(fetchDesignationFailure(error.message));
  }
}

function* fetchFromDepartmentSaga({ payload: { unit_id } }) {
  //  console.log("unit_id:",unit_id);
  try {
    const formData = new FormData();
    formData.append("unit_id", unit_id);
    const response = yield call(post, process.env.REACT_APP_GET_DEPARTMENTS, formData); // Replace with actual endpoint
    yield put(fetchDepartmentSuccess(response));
  } catch (error) {
    console.error("Saga API Error:", { payload: { unit_id } });
    yield put(fetchDepartmentFailure(error.message));
  }
}

function* fetchReportingSaga({ payload: { unit_id } }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", unit_id);
    const response = yield call(post, process.env.REACT_APP_EMPLOYEE_DROPDOWN_LIST, formData); // Replace with actual endpoint
    yield put(fetchReportingSuccess(response));
  } catch (error) {
    console.error("Saga API Error:", { payload: { unit_id } });
    yield put(fetchReportingFailure(error.message));
  }
} //fetchTransferLogsSaga

function* fetchTransferLogsSaga({ payload: { unit_id } }) {
  console.log("unit_id>>>", unit_id);
  try {
    const formData = new FormData();
    formData.append("unit_id", unit_id);
    const response = yield call(post, process.env.REACT_APP_FETCH_TRANSFERLOGS, formData); // Replace with actual endpoint
    yield put(fetchTransferLogsSuccess(response));
  } catch (error) {
    console.error("Saga API Error222:", { payload: { unit_id } });
    yield put(fetchTransferLogsFailure(error.message));
  }
}

//SaveTransferSaga
function* SaveTransferSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_TRANSFEREMPLOYEES, action.payload); // Replace with actual endpoint

    if (!response || response.status !== "success") { throw new Error(response?.message || "Failed to transfer employee!"); }
    yield put(SaveTransferSuccess(response));
    // Success alert
    Swal.fire({ title: "Success", text: response?.message, icon: "success", confirmButtonText: "OK", });
  } catch (error) {
    yield put(SaveTransferFailure(error));
    // Error alert
    console.log("error>>>", error);
    Swal.fire({ title: "Error", text: error.message, icon: "error", confirmButtonText: "OK", });
  }
}

function* getShiftGroupDetailsSaga(action) {
  try {
    const { unitid, groupid } = action.payload;

    const formData = new FormData();
    formData.append("unit_id", unitid);
    formData.append("group_id", groupid);

    const response = yield call(post, process.env.REACT_APP_FETCH_SHIFT_GROUP_DETAILS, formData);

    yield put({ type: GET_SHIFT_GROUP_DETAILS_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: GET_SHIFT_GROUP_DETAILS_FAILURE, payload: error });
  }
}

function* fetchEmployeeDropdownAutoExtraDutyListSaga({ payload: { unit_id } }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", unit_id);
    const response = yield call(post, process.env.REACT_APP_EMPLOYEE_DROPDOWN_EXTRADUTY_LIST, formData);
    yield put(fetchEmployeeDropdownAutoExtraDutyListSuccess(response));
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put(fetchEmployeeDropdownAutoExtraDutyListFailure(error.message));
  }
}

function* fetchNextEmpNoSaga({ payload }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", payload.unit_id);
    formData.append("cat_id", payload.cat_id);

    const response = yield call(
      post,
      process.env.REACT_APP_EMP_GET_SEQ_NO,
      formData
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to List the Employee Id!");
    }
    const nextEmpNo = response.data[0]?.NextEmpNo;
    yield put(fetchNextEmpNoSuccess(nextEmpNo));
  } catch (error) {
    yield put(fetchNextEmpNoFailure(error.message));
  }
}

function* fetchEmployeeDropdownAutoListMobilepunchSaga({ payload: { unit_id, create_by } }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", unit_id);
    formData.append("create_by", create_by);
    const response = yield call(post, process.env.REACT_APP_EMPLOYEE_DROPDOWN_AUTO_LIST_MOBILEPUNCH, formData);
    yield put(fetchEmployeeDropdownAutoListMobilePunchSuccess(response));
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put(fetchEmployeeDropdownAutoListMobilePunchFailure(error.message));
  }
}


// Watcher Saga
function* employeeSaga() {
  yield takeEvery(FETCH_EMPLOYEES_REQUEST, fetchEmployeesSaga);
  yield takeLatest(CREATE_EMPLOYEE_REQUEST, createEmployeeSaga);
  yield takeLatest(EMPLOYEE_DROPDOWN_REQUEST, fetchEmployeeDropdownSaga);
  yield takeLatest(EMPLOYEE_DROPDOWN_AUTO_LIST_REQUEST, fetchEmployeeDropdownAutoListSaga);
  yield takeLatest(FETCH_EMPLOYEE_TAB_WISE_INFO, fetchEmployeeTabWiseSaga);
  yield takeLatest(DELETE_DOCUMENT_REQUEST, deleteDocumentSaga);
  yield takeLatest(FETCH_ACTIVE_EMPLOYEES_REQUEST, fetchActiveEmployeesSaga);
  yield takeLatest(FETCH_EMPLOYEE_VIEW_PROFILE_REQUEST, fetchEmployeeViewProfileSaga);
  // Dinesh
  yield takeLatest(FETCH_TRANSFER_TYPES, fetchTransferTypesSaga);
  yield takeLatest(FETCH_FROM_CATEGORY, fetchFromCategorySaga);
  yield takeLatest(FETCH_FROM_DESIGNATION, fetchFromDesignationSaga);
  yield takeLatest(FETCH_FROM_DEPARTMENT, fetchFromDepartmentSaga); //FETCH_FROM_REPORTING
  yield takeLatest(FETCH_REPORTING, fetchReportingSaga);
  yield takeLatest(FETCH_EMPLOYEELISTTOTRANSFER, fetchEmployeeListSaga1);
  yield takeLatest(SAVE_TRANSFER_REQUEST, SaveTransferSaga);
  yield takeLatest(FETCH_TRANSFERLOGS, fetchTransferLogsSaga);
  yield takeLatest(CLEAR_EMPLOYEE_LIST, clearEmployeeList);
  yield takeLatest(GET_SHIFT_GROUP_DETAILS, getShiftGroupDetailsSaga);
  yield takeLatest(EMPLOYEE_DROPDOWN_AUTO_LIST_EXTRADUTY_REQUEST, fetchEmployeeDropdownAutoExtraDutyListSaga);
  yield takeLatest(FETCH_NEXT_EMP_NO_REQUEST, fetchNextEmpNoSaga);
  yield takeLatest(EMPLOYEE_DROPDOWN_AUTO_LIST_MOBILEPUNCH_REQUEST, fetchEmployeeDropdownAutoListMobilepunchSaga);

}

export default employeeSaga;
